import type { FaireProductEntity } from "../../entity_types/product";

export const p_exj3gbtxnv: FaireProductEntity = {
  token: "p_exj3gbtxnv",
  type: "product",
  name: "Moms Last Nerve Candle / Humorous Gift for Mom",
  brandToken: "b_sctqzguuyk",
  brandName: "THE DANCING WICK CANDLES",
  imageUrl:
    "https://cdn.faire.com/fastly/b6fb0446d47af5a6ee3fa5fe358ce702416ac6b929b0240539f4a5ecf9afdfec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d8b8dbf171634bac5365c733e4fa26c703aab78de59d19f7ffb059801904040.jpeg",
    "https://cdn.faire.com/fastly/a2b66b674b3266a026e3d728afc309b1126841d0129bddc8207805cb2c5bc5ba.jpeg",
    "https://cdn.faire.com/fastly/fd8ae0a2e1f66cc2953092ac9c1557174f1b96b48c6e19b06942f1732a92a898.jpeg",
    "https://cdn.faire.com/fastly/833197b34c82a2b89866869037f90e980ea8ed6b0299181af44c86562eab310d.jpeg",
    "https://cdn.faire.com/fastly/0e8a561c9ec52dc337c26530886f91854e2f7b37c94adc7814d4dcae1a634a63.jpeg",
    "https://cdn.faire.com/fastly/5b52e17ff8a64c35f74924d48d689a058b31949fbdc0df9e4d32e8ee9d78a0ab.jpeg",
    "https://cdn.faire.com/fastly/fc79605dcd9ea73373c5e90653ad2d12fbd8451d1171922a5c8f5b87bbfa2b5c.jpeg",
    "https://cdn.faire.com/fastly/150ab9acbecef74fc11b5cef6eb85bc8a212327b7634d6ed734c498d19bd5f69.jpeg",
    "https://cdn.faire.com/fastly/f80a97ef6208e77f503e839375ee12563b2be484f95b9302455ddb43a9d1c02f.jpeg",
    "https://cdn.faire.com/fastly/e8af00d432dd63da45689e13a4724851306b9219f6065788533b84cd0eee4209.jpeg",
  ],
  priceDollars: 10,
  description:
    '\nMom\'s Last Nerve Candle - The Perfect Mother\'s Day Gift\n\nLight this up, because Mom\'s last nerve? Yeah... it\'s officially toast. Our “Mom’s Last Nerve” candle is the hilarious (and painfully accurate) gift every mom didn’t know she needed. Whether it’s the endless snack requests, the laundry pile that reproduces overnight, or just general chaos – this candle says what she’s thinking, but with fire. Add a personal message to really drive the sarcasm home. Perfect for Mother’s Day, birthdays, or any day she deserves a laugh (which, let’s be real, is every day).\n\nOrder now and give your mom a gift that will warm her heart and her home.\n\n✨ Available Sizes: 4 oz, 8 oz, and 16 oz\n*4 oz dimensions are - 2.7" high x 2.35" around;\n*8 oz dimensions are 3.6" high x 2.6" around;\n*16 oz dimensions are 5.2" high x 3" around\n\nCATEGORIES\nmother’s day candle, mom gift candle, sentimental gift for mom, home quote candle, family love candle, gift from daughter or son, cozy home decor candle, soy candle wholesale, handmade soy candle, amber jar candle, meaningful gift candle, women-owned brand, everyday gift for mom\n',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:46.407Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
